module.exports = __webpack_public_path__ + "img/3.4c0068e8.jpg";